import { useLocation } from "react-router-dom";
import Profile from "@/pages/Profile/Profile";

const ProfileWrapper = () => {
  const location = useLocation();
  return <Profile key={location.key} />;
};

export default ProfileWrapper;
